import { useCopyAPIKeyIntegration } from "../CopyAPIKeyModal/useCopyAPIKeyIntegration";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import MakeLogo from "./MakeLogo";
import { jsx as _jsx } from "react/jsx-runtime";
export default function MakeCard() {
  const {
    showCopyAPIKeyModal
  } = useCopyAPIKeyIntegration('make');
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "make-card",
    icon: /*#__PURE__*/_jsx(MakeLogo, {}),
    title: "Make",
    subTitle: "Connect Anchor to any app or API to automate your workflows",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: showCopyAPIKeyModal,
      "data-testid": "make-card-connect",
      children: "Connect"
    })
  });
}